import { render, staticRenderFns } from "./shop-categories.vue?vue&type=template&id=1cc2d64b&"
import script from "./shop-categories.vue?vue&type=script&lang=js&"
export * from "./shop-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports